import { appServiceClient } from '@/infrastructure/http/httpClient';

import { ImplantacaoPendenciasResult } from '../interfaces/implantacao';
import { IImplantacaoPendenciasMaquinas } from '../interfaces/pendenciasDeMaquina';

class ImplantacaoRepository {
  async pendencias(): Promise<ImplantacaoPendenciasResult> {
    return appServiceClient.get<ImplantacaoPendenciasResult>('implantacao/pendencias');
  }

  /** Os nomes por tras dos dois contadores de maquina, para a tela de destino listar. */
  async pendenciasDeMaquina(): Promise<IImplantacaoPendenciasMaquinas> {
    return appServiceClient.get<IImplantacaoPendenciasMaquinas>('implantacao/pendencias/maquinas');
  }
}

export const implantacaoRepository = new ImplantacaoRepository();
